<div class="w-full max-w-4xl">
    <mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent">
        <!-- Drawer -->
        <mat-drawer class="w-full md:w-160 dark:bg-gray-900" [mode]="drawerMode" [opened]="false" [position]="'end'"
            [disableClose]="true" #matDrawer>
            <router-outlet></router-outlet>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col">
            <!-- Main -->
            <div class="flex-auto">
                <!-- Header -->
                <div id="header"
                    class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b">
                    <!-- Title -->
                    <div>
                        <div class="text-4xl font-extrabold tracking-tight leading-none">
                            {{ 'label_registered_user' | translatePlural }}
                        </div>
                        <div class="ml-0.5 font-medium text-secondary">
                            {{ 'label_user_count' | translate: { count: usersCount } }}
                        </div>
                    </div>
                    <!-- Main actions -->
                    <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                        <!-- Search -->
                        <div class="flex-auto">
                            <mat-form-field
                                class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                <input matInput [formControl]="searchInputControl" [autocomplete]="'off'"
                                    [placeholder]="'Leita að notanda'" />
                            </mat-form-field>
                        </div>
                        <!-- Add contact button -->
                        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="addUser()">
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
                        </button>
                    </div>
                </div>
                <!-- Users list -->
                <div class="relative">
                    @if (searchedUsers?.length != 0) {
                    @for (user of searchedUsers; track trackByFn(i, user); let i = $index) {
                    <!-- Group -->
                    @if (
                    i === 0 ||
                    user.displayName.charAt(0).toUpperCase() !== searchedUsers[i -
                    1].displayName.charAt(0).toUpperCase()
                    ) {
                    <div
                        class="z-10 sticky top-0 -mt-px px-6 py-1 md:px-8 border-t border-b font-medium uppercase text-secondary bg-gray-50 dark:bg-gray-900">
                        {{ user.displayName.charAt(0) }}
                    </div>
                    }
                    <!-- User -->
                    <span #userRow
                        class="z-20 flex items-center px-6 py-4 md:px-8 overflow-x-hidden cursor-pointer border-b h:cursor-pointer"
                        (click)="viewUserDetails(user)">
                        <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full">
                            <ng-container>
                                <img class="object-cover w-full h-full" src="/assets/images/user/user.jpg" alt="Mynd" />
                            </ng-container>
                        </div>
                        <div class="w-100 ml-4">
                            <div class="font-medium leading-5 truncate">
                                {{ user.displayName }}
                            </div>
                            <div class="flex flex-wrap sm:flex-nowrap">
                                <span class="flex flex-row grow">
                                    {{ user.mailNickname ? user.mailNickname : user.email
                                    }}{{ user.kennitala ? ', kt. ' + formatKennitala(user.kennitala) : ''
                                    }}{{ user.jobTitle ? ' - ' + user.jobTitle : ''
                                    }}{{ user.officeLocation ? ', ' + user.officeLocation : '' }}
                                </span>
                                <span class="hidden md:flex flex-row shrink gap-2">
                                    @if (user.isEmployee) {
                                    <div
                                        class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal bg-gray-100">
                                        <span class="text-sm font-medium whitespace-nowrap">
                                            {{ 'label_role_employee_lsr' | translate }}
                                        </span>
                                    </div>
                                    }
                                    @if (user.isExternalEmployee) {
                                    <div
                                        class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal bg-gray-100">
                                        <span class="text-sm font-medium whitespace-nowrap">
                                            {{ 'label_external_employee' | translate }}
                                        </span>
                                    </div>
                                    }
                                    @if (user.isUserManager) {
                                    <div
                                        class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal text-white bg-gray-100 bg-primary-500">
                                        <span class="text-sm font-medium whitespace-nowrap">
                                            {{ 'label_role_user_management' | translate }}
                                        </span>
                                    </div>
                                    }
                                </span>
                            </div>
                        </div>
                    </span>
                    }
                    @if (nextCursor) {
                    <div #sentinel class="h-1"></div>
                    }
                    }
                    <!-- No users -->
                    @if (hasHttpFetched && searchedUsers?.length == 0) {
                    <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center" #noUsers>
                        {{ 'info_no_user_found' | translatePlural }}
                    </div>
                    }
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>